<template>
  <el-dialog
    title="訂閱外部頻道"
    append-to-body
    :visible.sync="innerVisible"
    @close="handleDlgClose"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <!--<el-form-item label="所屬單位" :label-width="formLabelWidth">-->
      <!--<el-input :value="myownOrg" readonly autocomplete="off"></el-input>-->
      <!--</el-form-item>-->

      <el-form-item label="頻道名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="外部頻道名稱"
        :label-width="formLabelWidth"
        prop="parentName"
      >
        <el-input :value="parentName" readonly autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth">
        <el-switch
          v-model="form.isPublic"
          active-text="公開"
          inactive-text="非公開"
        ></el-switch>
      </el-form-item>

      <!--<el-form-item :label-width="formLabelWidth" label="">-->
      <!--<el-switch-->
      <!--v-model="form.enableAssign"-->
      <!--active-text="啟用 頻道管理員個人授權功能"-->
      <!--inactive-text="關閉" ></el-switch>-->
      <!--</el-form-item>-->


      <el-form-item label="顏色" :label-width="formLabelWidth" prop="color">
        <div style="width:480px;marginBottom:-20px">
          <el-radio-group v-model="form.color">
            <el-radio
              v-for="itemColor in extTagColorList"
              :key="itemColor.name"
              :label="itemColor.name"
            >
              <span :style="{ color: itemColor.textColor }">
                {{ itemColor.txtLabel }}
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>

    </el-form>
    <template #footer class="dialog-footer">
      <div v-loading="isLoading">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">確 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import tagColorsMixin from "@/components/mixin/tagColors.js";
//import API from "@/api/";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedChnl: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "請輸入頻道名稱", trigger: "blur" }],
        color: [{ required: true, message: "請輸入顏色", trigger: "blur" }],
      },
      isLoading: false,
      formLabelWidth: "100px",
      parentName: "",
      form: {
        name: "",
        isPublic: true,
        color: "primary",
        enableAssign: false,
      },
    };
  },
  created() {
    if (this.innerVisible) {
      //console.log(`AddExtChnlDlg: this.selectedChnl = ${JSON.stringify(this.selectedChnl)}`);
      if (this.selectedChnl) {
        this.form.name = this.selectedChnl.name;
        this.form.isPublic = true;
        this.form.color = this.selectedChnl.color;
        this.form.parentId = this.selectedChnl.id;
        this.form.enableAssign = false;
        this.parentName = this.selectedChnl.name;
      }
    }
  },
  methods: {
    cancel() {
      this.innerVisible = false;
      //this.$emit("subscribed", { isSubs: false, childId: null });
    },
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.submitAdd();
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      //console.log(
      //`submitAdd: adminIds = ${JSON.stringify(this.form.adminIds)}`
      //);
      this.isLoading = true;
      this.$store
        .dispatch("channel/add", this.form)
        .then(res => {
          this.innerVisible = false;
          this.$emit("subscribed", { isSubs: true, childId: res.data.id });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleDlgClose() {
      this.$emit("subscribed", { isSubs: false, childId: null });
    },
  },
};
</script>

<style></style>
